module.exports = ".login-logo {\r\n  display: inline-block;\r\n  width: 28px;\r\n  height: auto;\r\n  vertical-align: middle;\r\n}\r\n\r\n.login-title {\r\n  padding-top: 6px;\r\n  font-size: 34px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/common/login/login.component.css
// module id = ./src/app/pages/common/login/login.component.css
// module chunks = main